const en = {
  Back: 'Back',
  BrowserRequirements: 'Browser Requirements',
  Clickhere: 'Click here',
  Loading: 'Loading...',
  Unsupportedbrowserversion1:
    "Sage Intelligent Time doesn't support the version of this web browser. Update your browser to the most current version. ",
  Unsupportedbrowserversion2: ' to see a list of supported browsers.',
  activities: {
    Activities: 'Activities',
    Assigned: 'Assigned',
    DropPoolText: 'Drop the activity here to mark it as unassigned',
    Unassigned: 'Unassigned',
  },
  approvals: {
    ApprovalHistory: 'Approval History',
    Approvals: 'Approvals',
    Approvalstage: 'Approval stage',
    Approvaltype: 'Approval type',
    Approve: 'Approve',
    ApproveAll: 'Approve All',
    ApprovedDeclinedby: 'Approved/Declined by',
    ApproveTimesheet: 'Approve Timesheet',
    ApproveTimesheetX: {
      one: 'Approve Timesheet',
      other: 'Approve Timesheets',
    },
    Back: 'Back',
    Billable: 'Billable',
    Cancel: 'Cancel',
    CollapseAll: 'Collapse All',
    Commentoptional: 'Comment (optional)',
    Comments: 'Comments',
    Customer: 'Customer',
    Decline: 'Decline',
    DeclineAll: 'Decline All',
    DeclineTimesheet: 'Decline Timesheet',
    DeclineTimesheetX: {
      one: 'Decline Timesheet',
      other: 'Decline Timesheets',
    },
    Description: 'Description',
    Details: 'Details',
    Done: 'Done',
    Employee: 'Employee',
    Entries: 'Entries',
    Eventdate: 'Event date',
    ExpandAll: 'Expand All',
    GroupBy: 'Group By',
    Notes: 'Notes',
    Notimesheetstoapprove: 'No timesheets to approve',
    Ok: 'Ok',
    Pleaseselectatleastonerowtoapprove: 'Please select at least one row to approve.',
    Pleaseselectatleastonerowtodecline: 'Please select at least one row to decline.',
    Project: 'Project',
    State: 'State',
    Submittedto: 'Submitted to',
    Task: 'Task',
    TimeType: 'Time Type',
    TimeEntries: 'Time Entries',
    TimeEntryDetailsfor: 'Time Entry Details for %{date}',
    TimesheetApprovals: 'Timesheet Approvals',
    TimesheetPeriod: 'Timesheet Period',
    ToDo: 'To Do',
    TotalBillable: 'Total Billable',
    TotalHours: 'Total Hours',
    TotalHoursX: 'Total Hours - %{hours}',
    TotalNonBillable: 'Total Nonbillable',
    TotalTimesheets: 'Total Timesheets',
    Xentriesselected: '%{total} entries selected',
    XEntriesSelected: '**%{total}** Entries Selected',
    XTimesheetsSelected: '**%{total}** Timesheets Selected',
    YouhavechosentoapproveX: {
      one: 'You have chosen to approve the below entries.',
      other: 'You have chosen to approve the below timesheets.',
    },
    YouhavechosentodeclineX: {
      one: 'You have chosen to decline the below entries.',
      other: 'You have chosen to decline the below timesheets.',
    },
    ViewDetails: 'View Details',
  },
  auth: {
    Alreadyhaveaccount: 'Already have an account?',
    Cancel: 'Cancel',
    Cantfindthatemail: 'Can’t find that email? Try checking your spam folder.',
    CantfindthatemailRegister: 'Can’t find that email? Try checking your spam folder or click on Resend Email.',
    CheckYourEmail: 'Check your Email',
    CompanyID: 'Company ID',
    CompanyName: 'Company Name',
    ConfirmPassword: 'Confirm Password',
    CreateAccount: 'Create Account',
    DisplayName: 'Display Name',
    Donthaveaccount: "Don't have an account?",
    Email: 'Email',
    Username: 'Intacct User ID',
    Entertheemailasociatedwith:
      'Enter the email and the Intacct company ID associated with your Sage Intelligent Time account and we’ll send you instructions to reset your password.',
    FirstName: 'First Name',
    Forgotpassword: 'Forgot your password?',
    ForgotYourPassword: 'Forgot Your Password',
    here: 'here',
    HIDE: 'HIDE',
    Ifyoustillcantlogin: 'If you still can’t login, have us resend the email or contact your Sage Intelligent Time administrator.',
    IntacctCompanyID: 'Intacct Company ID',
    IntacctUserID: 'Intacct User ID',
    InviteError: 'Token invalid',
    LastName: 'Last Name',
    LogIn: 'Log In',
    LoginSSO: 'Log in with Single Sign On (SSO)',
    LooksLikePasswordProtectionPageBypassed: 'Looks like the password protection page got bypassed. Please refresh the page and try again.',
    Next: 'Next',
    Openitupand: " Open it up and click Activate Account. We'll take it from there.",
    Password: 'Password',
    PasswordsDontMatch: "Passwords don't match",
    Pleaseinputpassword: 'Please input the password to continue',
    Resend: 'Resend',
    ResendEmail: 'Resend Email',
    ReturntoLogin: 'Return to Login',
    ReturntoSignUp: 'Return to Sign Up',
    SHOW: 'SHOW',
    SignUp: 'Sign Up',
    SITPassword: 'SIT Password',
    Securitycode: 'Security code',
    Submit: 'Submit',
    Toreceiveacodeviaemailclick: 'To receive a code via e-mail click ',
    UserID: 'User ID',
    Wesentacodetoyourphone: 'We sent a code to your **phone number**.',
    Wesentacodetoyouremail: 'We sent a code to your **e-mail**',
    WevepulledyourCompanyIDandUserIDfromIntacct:
      "We ve pulled your Company ID and User ID from Intacct. Please create a new password specifically for Sage Intelligent Time. You'll use these three credentials to login. Note, this will not change how you login to Intacct.",
    Wevesentanemailto: "We've sent an email to ",
    Youllreceiveanemailfrom: 'You’ll receive an email from Sage Intelligent Time shortly with a link to reset your password.',
  },
  clusters: {
    Activitycardmarkedastrash: 'Activity card marked as trash.',
    Activitycardmarkedasnotattended: 'Activity card marked as not attended.',
    Anewrow: 'A new row',
    Assign: 'Assign',
    AssignActivityCard: 'Assign Activity Card',
    Assignactivitycardas: 'Assign activity card as',
    Back: 'Back',
    Billable: 'Billable',
    CalendarEvent: 'Calendar Event',
    Cancel: 'Cancel',
    CancelSplit: 'Cancel Split',
    clusterIsLocked: 'Activity card is locked.',
    clusterInXTimesheetEntry: 'Activity card associated with %{status} timesheet entry.',
    ComputerActivity: 'Computer Activity',
    Customer: 'Customer',
    Date: 'Date',
    Delete: 'Delete',
    Department: 'Department',
    Description: 'Description',
    Didnotattend: 'Did not attend',
    Droppedonemptyrow: 'You selected to assign this activity to an existing empty row',
    EmailActivity: 'Email Activity',
    Ifyouwouldliketomovetheactivitytoadifferentproject:
      'If you would like to move the activity to a different project, instead of merging, please click back and edit the assignment details.',
    Item: 'Item',
    Location: 'Location',
    Merge: 'Merge',
    Mergedwithexistingrow: 'Merged with existing row',
    MergeEntries: 'Merge Entries',
    NewRow: 'New Row',
    Noactivitiestoassign: 'No activities to assign',
    Noassignedactivities: 'No assigned activities',
    Notes: 'Notes',
    OverlapMessage: 'This activity overlaps with another calendar event. Removing %{clusters} will unlock this activity.',
    Project: 'Project',
    Reassign: 'Reassign',
    Select: 'Select',
    Selecttherowyouwouldliketomergewith: 'Select the row you would like to merge with.',
    Split: 'Split',
    Task: 'Task',
    TimeType: 'Time Type',
    Trash: 'Trash',
    Unassign: 'Unassign',
    UndefinedClusterType: 'Unknown Activity type',
    Xmatching: ' (%{amount} matching)',
    YourcardsforcalendarAssigned: 'Your cards for calendar, computer, and email activity will appear here once they’ve been assigned.',
    YourcardsforcalendarUnassigned: 'Your cards for calendar, computer, and email activity will appear here.',
  },
  dataSources: {
    Account: 'Account',
    AddtheChromeextensiontoenhancedatagatheredinChrome: 'Add the Chrome extension to enhance data gathered in Chrome.',
    albert_good: 'Successfully running the Time Assistant.',
    albert_inactive: 'Your Time Assistant is either paused or not running right now. Please allow 3 hours after installation to connect.',
    albert_not_yet_synced: 'Sage Time Assistant not installed.',
    albert_wrong_settings: 'Your Time Assistant settings are not configured correctly.',
    Areyousuredeleteaccount: 'Are you sure you want to delete this account?',
    ByclickingbelowCalendar:
      'By clicking below to connect your calendar application account(s) means that you agree to our use of your calendar data as stated below and detailed in the ',
    ClickingbelowEmail:
      'Clicking below to connect your email account(s) means that you agree to our use of your email data as stated below and detailed in the ',
    ClickingDownloadTimeAssistant:
      'Clicking “Download Time Assistant” means that you agree (1) to install the Time Assistant app and any future updates and upgrades by Sage and (2) to opt into our collection and use of your personal data as stated below and detailed in the ',
    cal_good: 'Successfully connected your calendar!',
    cal_inactive: "You have connected your calendar but we don't have any events from you recently. Please contact support.",
    Calendar: 'Calendar',
    calendarActive: 'This calendar is connected.',
    calendarInactive: 'This calendar is not connected.',
    CalendarSyncedSuccessfully: 'Calendar Synced Successfully',
    Cancel: 'Cancel',
    Checkthecheckboxbelowto:
      'Check the checkbox below to also delete the generated activity cards associated with this data source. If you choose not to delete them, you can request at a later date that they be deleted by contacting customer support.',
    Synconeormoreaccountsbyselectingyourcloudprovider: 'Sync one or more accounts by selecting your cloud provider.',
    chrome_ext_good: 'Successfully installed the Chrome extension.',
    chrome_ext_not_yet_installed: 'Chrome Extension not installed',
    ChromeExtension: 'Chrome Extension',
    Connect: 'Connect',
    ConnectAccount: 'Connect Account',
    ConnectAnother: 'Connect Another',
    Connectanothercalendar: 'Connect another calendar',
    Connectanothercalendartoautogeneratetimeentries: 'Connect another calendar to auto-generate time entries.',
    Connectanotheremail: 'Connect another email',
    Connectanotheremailaccounttoautogeneratetimeentries: 'Connect another email account to auto-generate time entries.',
    Connectanyofthedatasources: 'Connect any of the data sources above in order to automate and AI-power your timesheets.',
    ConnectCalendar: 'Connect Calendar',
    ConnectedDataSources: 'Connected Data Sources',
    ConnectEmail: 'Connect Email',
    Connection: 'Connection',
    Continue: 'Continue',
    DataRetentionPeriod: 'Data Retention Period',
    DataSource: 'Data Source',
    DataSources: 'Data Sources',
    DatayouprovideCalendar:
      '**Data you provide:** Calendar information from the time you give consent onward and the week prior to consent date, including content like event description and attachment names, header information like sender, recipients and start and end time, and metadata like created and updated dates.',
    DatayouprovideEmail:
      '**Data you provide:** Email information from the time you give consent onward, including content like email text and attachment file names, header information like sender, recipients and sent time stamp, and metadata like created and updated dates.',
    DatayouprovideTracker:
      '**Data you provide and app function:** The Time Assistant app collects and transmits to the Sage Intelligent Time service the following information: Activity data from the time you give consent onward like operating system and device type; information related to your interaction with the system like how many times you interacted with your computer since your computer was last idle (we do not record keystrokes); and application use data like active application name, timestamp of when you switched active application windows, and URLs of websites in open browser applications.',
    days: 'days',
    Delete: 'Delete',
    DeleteAccount: 'Delete Account',
    Deleteactivitycards: 'Delete activity cards',
    DeleteandReConnectAccount: 'Delete and Re-connect Account',
    description:
      "After you've connected data sources, Sage Intelligent Time learns your work activities and automatically pre-populates your timesheet with AI-powered predictions. You maintain control over your data. Only you can see the data gathered.",
    Disclosedto: '**Disclosed to:** The Sage Group plc or a subsidiary (the controller, as to you; the processor, as to your employer).',
    DisclosedtoTracker:
      '**Disclosed to:** The Sage Group plc or a subsidiary (the processor of data for timesheets; the controller of algorithm training data) is seeking your consent and receives the data from the Time Assistant.',
    Disconnect: 'Disconnect',
    documentation: 'documentation.',
    downloaded_not_running:
      "You've downloaded the Time Assistant but you either haven't logged in to the app or you haven't run the installer yet.",
    Download: 'Download',
    DownloadTimeAssistant: 'Download Time Assistant',
    DownloadtheTimeAssistant: 'Download the Time Assistant',
    DownloadtheTimeAssistanttotracktime: 'Download the Time Assistant to track time spent on your Mac or PC.',
    email_good: 'Successfully connected your email.',
    email_inactive: 'Connection initiated but no emails found. Please contact support.',
    Email: 'Email',
    EmailSyncedSuccessfully: 'Email Synced Successfully',
    Error: 'Error',
    FailedtolaunchTimeAssistant: 'Failed to launch Time Assistant. Please open it manually.',
    forhelp: ' for help.',
    GoogleCalendar: 'Google Calendar',
    GoogleEmail: 'Google Email',
    Help: 'Help',
    here: 'here',
    Howtooptout: '**How to opt out:** Click "disconnect" next to the account in the data sources page.',
    HowtooptoutTracker1: '**How to opt out:** If you choose not to install, or disconnect and uninstall as described in the ',
    HowtooptoutTracker2:
      ' Time Assistant, you may still use Sage Intelligent Time to create timesheets. Should you choose to download and install Time Assistant, you can withdraw your consent to its operation, updates and upgrades at any time by uninstalling the app as described for your operating system here: ',
    HowtooptoutTracker3: 'For assistance, please contact Intacct Support by ',
    HowtooptoutTracker4: ' or writing Sage Intacct, ATTN: Support, 300 Park Ave, Suite 1400, San Jose, CA 95110.',
    InitiatedNoData: 'Connection initiated but no data found.',
    Inordertoreconnectyouraccount:
      "In order to re-connect your account, you'll need to delete this connection and then connect your account again. This will delete all data associated with this data source.",
    Install: 'Install',
    Installtheapplicationtocapturecomputeractivity: 'Install the application to capture computer activity.',
    Launch: 'Launch',
    LaunchedTimeAssistant: "Time Assistant launched. If it didn't start please open it manually or check if it is already running.",
    MicrosoftOutlookCalendar: 'Microsoft Outlook Calendar',
    MicrosoftOutlookEmail: 'Microsoft Outlook Email',
    missing_permissions_title: 'Missing Permissions',
    missing_permissions_message:
      'The option “**See and download any calendar you can access using your Google Calendar**” needs to be selected in order to connect your calendar.',
    no_active_calendars: 'No calendars selected. Connect a calendar below to retrieve calendar events.',
    no_cal_token_try_again: 'You unsuccessfully attempted to connect your calendar. Please try again.',
    no_cals_syncing: 'Connection initiated but no events found. Please contact support.',
    no_email_token_try_again: 'You unsuccessfully attempted to connect your email.',
    no_emails_syncing: 'Connection initiated. However, no emails have been retrieved yet. Please contact support.',
    NoCalendar: 'Calendar not connected',
    NoData: 'No data.',
    NoDataSourcesConnected: 'No Data Sources Connected',
    NoEmail: 'Email not connected',
    NotApplicable: 'N/A',
    PrivacyPolicy: 'Privacy Policy',
    Provider: 'Provider',
    Pullincalendareventstoautogenerateentries: 'Pull in calendar events to auto-generate entries.',
    Pullinemailstoautogeneratetimesheetentries: 'Pull in emails to auto-generate timesheet entries.',
    ReConnect: 'Re-connect',
    ReConnectAccount: 'Re-connect Account',
    ReDownload: 'Re-download',
    Retaineduntil:
      '**Retained until:** When connecting your account, you will be prompted to choose how long we retain your data. You can change this setting at any time.',
    RetainMyCalendarDataFor: 'Retain My Calendar Data For',
    RetainMyEmailDataFor: 'Retain My Email Data For',
    RetainMyTimeAssistantDataFor: 'Retain My Time Assistant Data For',
    ReturntoDataSources: 'Return to Data Sources',
    SageIntelligentTimeretainsdatafromtheaccounts:
      'Sage Intelligent Time retains data from the account(s) you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data may impact the quality of these predictions and consequently the accuracy and the time it takes for you to complete your timesheets. You may change this setting at any time.',
    Save: 'Save',
    SetDataRetentionPeriodForThisAccount: 'Set Data Retention Period For This Account',
    Status: 'Status',
    StatusMessage: 'Status Message',
    submittingasupportticketinthecommunityportal: 'submitting a support ticket in the community portal',
    SuccessCalendar: 'Successfully connected your calendar.',
    SuccessEmail: 'Successfully connected your email.',
    Syncanotheremailorreturntodatasources: 'Sync another email or return to data sources.',
    Syncanothercalendarorreturntodatasources: 'Sync another calendar or return to data sources.',
    Syncyourdatatogetautogeneratedtimesheets: 'Sync your data to get auto-generated timesheets.',
    Thiscannotbeundone: 'This cannot be undone.',
    Thiswilldelete: 'This will delete all data associated with this data source.',
    TimeAssistant: 'Time Assistant',
    UnsupportedOS: 'Unsupported OS',
    Usedfor:
      '**Used for:** To help you create timesheet entries and to train algorithms that automate creation of timesheet entry descriptions.',
    wait_for_cals: 'You recently connected your calendar. Please wait for up to 24 hours for the initial connection to complete',
    wait_for_emails: 'You recently connected your email. Please wait for up to 24 hours for the initial connection to complete.',
    YoumustalsouninstallTimeAssistantfromyourdesktop:
      'You must also uninstall Time Assistant from your desktop computer as described in the ',
    YouvedownloadedTimeAssistant: "You've downloaded Time Assistant. Click ",
  },
  empty: {
    NoData: 'No Data',
  },
  entries: {
    Billable: 'Billable',
    Customer: 'Customer',
    Department: 'Department',
    Item: 'Item',
    Location: 'Location',
    NegativeHours: 'Negative Hours',
    Project: 'Project',
    Select: 'Select',
    Task: 'Task',
    TimeType: 'Time Type',
    TotalHours: 'Total Hours',
    TotalEstimated: 'Total Estimated',
    TotalAllocated: 'Total Allocated',
  },
  entry: {
    ActivityCards: 'Activity Cards',
    AddNotes: 'Add Notes',
    AddNotesAndDimensions: 'Add Notes and Dimensions',
    AreYouSure: 'Are you sure you would like to delete the timesheet row for %{cpti}?',
    Cancel: 'Cancel',
    Client: 'Client',
    DeleteRow: 'Delete Row',
    Deletingtherowwill: 'Deleting the row will reset any activities that were assigned to the row.',
    Department: 'Department',
    Description: 'Description',
    Dimensions: 'Dimensions',
    EditNotes: 'Edit Notes',
    Item: 'Item',
    Location: 'Location',
    Notes: 'Notes',
    KeepRow: 'Keep Row',
    NoCustomer: 'Please select a Customer',
    NoProject: 'Please select a Project',
    NoTask: 'Please select a Task',
    NoItem: 'Please select a Item',
    OK: 'OK',
    Project: 'Project',
    Task: 'Task',
    Thiscannotbeundone: 'This cannot be undone.',
    TimeType: 'Time Type',
    Youcannotdeletethisrow:
      "You cannot delete this row because Intacct doesn't allow blank timesheets. Add a new row with at least one entry to be able to delete this row.",
  },
  errors: {
    messages: {
      blank: 'This field is required',
      invalid_email: 'Invalid email address',
      generic_request_error: "Oops! We can't connect to the server right now. Please wait a few minutes before refreshing the page.",
    },
  },
  helmet: {
    Approvals: 'Approvals | Sage Intelligent Time',
    DataSources: 'Data Sources | Sage Intelligent Time',
    Home: 'Home | Sage Intelligent Time',
    Intacct: 'Intacct | Sage Intelligent Time',
    InternalAdminDashboard: 'Internal Admin Dashboard | Sage Intelligent Time',
    Login: 'Login | Sage Intelligent Time',
    Privacy: 'Privacy | Sage Intelligent Time',
    Provision: 'Provision | Sage Intelligent Time',
    SAML: 'SAML | Sage Intelligent Time',
    Settings: 'Settings | Sage Intelligent Time',
    Timesheets: 'Timesheets | Sage Intelligent Time',
  },
  homepage: {
    AIPowered: 'AI-Powered',
    Aneweraintimeentry: 'A new era in time entry',
    Billmoretimeandspendlesstimeontimeentry: 'Bill more time and spend less time on time entry',
    Createmanualentries: 'Create manual entries',
    Formodernservicebusinesses: 'For modern service businesses. AI-powered. Available on web, iOS, and Android.',
    Legal: 'Legal',
    Maintainfullcontroloveryourconnecteddata:
      'Maintain full control over your connected data sources - see our Privacy Policy to learn more',
    Managetimesheetnotifications: 'Manage timesheet notifications',
    PrivacyPolicy: 'Privacy Policy',
    Reachouttoourteamtodaytogetademo: 'Reach out to our team today to get a demo',
    SageIntelligentTimeisavailableanytime: 'Sage Intelligent Time is available anytime and anywhere with our mobile app.',
    SageIntelligentTimeushers:
      'Sage Intelligent Time ushers in a new era in time entry. Set time tracking on auto-pilot with our AI-powered web and mobile solution.',
    TermsofService: 'Terms of Service',
    Timesheets: 'Timesheets',
    Timesheetsforbusinessesthataregoingplaces: 'Timesheets for businesses that are going places',
    Useyourcalendaremailandcomputeractivity: 'Use your calendar email and computer activity to easily create accurate timesheet entries',
    Withourmobileappyoucandothefollowing: 'With our mobile app, you can do the following:',
  },
  intacct: {
    Approximatelyminutesremaining: 'Approximately %{x} minutes remaining...',
    CompanyId: 'Company ID',
    ConnectToIntacct: 'Connect to Intacct',
    GoToTimesheets: 'Go to Timesheets',
    HIDE: 'HIDE',
    IntacctConnectionInProgress: 'Intacct Connection In Progress',
    IntacctLogIn: 'Intacct Log In',
    LogIn: 'Log In',
    Password: 'Password',
    Readaccessofyour: 'Read access of your %{value}',
    Readwriteaccessto: 'Read/write access to %{value}',
    ReSync: 'Re-sync',
    Retry: 'Retry',
    SHOW: 'SHOW',
    Subtitle:
      "Click the button below to connect your company's Sage Intelligent Time account with Sage Intacct. By doing so, you are granting access to the following:",
    SuccessMsg: 'You successfully synced your intacct data',
    UserId: 'Web Services User ID',
    Werecurrentlyconnecting:
      "We're currently connecting to your Intacct instance. This usually takes no more than 5 minutes. You can view the progress of the connection via the progress bar below. We will also email you when the connection is complete.",
  },
  intacctAdmin: {
    AdminUsername: 'Admin Username',
    AdminUserEmail: 'Admin User Email',
    Back: 'Back',
    ChangeEntity: 'Change Entity',
    Clearalldataforce: 'Clear all data (force)',
    CurrentEntity: 'Current Entity: **%{entity}**',
    Deactivate: 'Deactivate',
    Reactivate: 'Reactivate',
    Delete: 'Delete',
    DeactivateCompanyInstance: 'Deactivate Company Instance',
    ReactivateCompanyInstance: 'Reactivate Company Instance',
    DeleteCompanyInstance: 'Delete Company Instance',
    EmailAddress: 'Email Address',
    forceHelp: 'Check this box to force deletion of existing data, if the company has already been provisioned with an entity',
    GetEntities: 'Get Entities',
    GrantSITAdminPermissions: 'Grant SIT Admin Permissions',
    IntacctCompanyID: 'Intacct Company ID',
    Pleaseselectanentity: 'Please select an entity',
    ResendInvitation: 'Resend Invitation',
    ResendSITAdminInvitation: 'Re-send SIT Admin Invitation',
    ResetMFA: 'Reset MFA',
    Revoke: 'Revoke',
    RevokeSITAdminPermissions: 'Revoke SIT Admin Permissions',
    Save: 'Save',
    Step1RetrievecompanyEntities: 'Step 1: Retrieve company Entities',
    Step2SelectenewEntity: 'Step 2: Select new Entity',
    Success: 'Success',
    SuccessfulDeactivationMessage: "You've successfully deactivated **%{companyID}**'s Sage Intelligent Time account.",
    SuccessfulReactivationMessage: "You've successfully reactivated **%{companyID}**'s Sage Intelligent Time account.",
    SuccessfulDeleteMessage: "You've successfully deleted **%{companyID}**'s Sage Intelligent Time account.",
    SuccessfulEntityChangeMessage: "You've successfully updated **%{companyID}**'s Sage Intelligent Time company Entity.",
    SuccessfulGrantAdminMessage: "You've successfully granted Admin permissions to **%{username}**.",
    SuccessfulResendMessage:
      'Your invitation has been successfully sent. If the user still does not receive the invitation, please send them this link: %{inviteLink}',
    SuccessfulRevokeAdminMessage: "You've successfully revoked Admin permissions from **%{username}**.",
    Thisfieldisrequired: 'This field is required',
    UpdateCompanyEntity: 'Update Company Entity',
    Username: 'Username',
    UserEmail: 'User Email',
  },
  navigation: {
    Approvals: 'Approvals',
    DataSources: 'Data Sources',
    Intacct: 'Intacct',
    Loggedinas: 'Logged in as',
    LogIn: 'Log In',
    Logout: 'Logout',
    Privacy: 'Privacy',
    Settings: 'Settings',
    Thirdpartylicences: '3rd party licenses',
    Timesheets: 'Timesheets',
  },
  notFound: {
    GoBack: 'Go Back',
    Sorrythispageisntavailable: "Sorry, this page isn't available.",
    Thelinkyoufollowed: 'The link you followed may be broken, or the page may have been removed.',
  },
  notifications: {
    Earlier: 'Earlier',
    New: 'New',
    NoNotifications: 'No Notifications',
    Notifications: 'Notifications',
    SeeAllNotifications: 'See All Notifications',
  },
  notification: {
    toasts: {
      SAVE_TIMESHEET: {
        SUCCESS: 'Your timesheet has been successfully synced to Intacct',
        ERROR: 'Your timesheet has failed to sync to Intacct',
      },
      SUBMIT_TIMESHEET: {
        SUCCESS: 'Your timesheet has been successfully submitted',
        ERROR: 'Your timesheet failed to submit',
      },
    },
  },
  pill: {
    Active: 'Active',
    Approved: 'Approved',
    Declined: 'Declined',
    Draft: 'Draft',
    Error: 'Error',
    Inactive: 'Inactive',
    InvitationSent: 'Invitation Sent',
    Invoiced: 'Invoiced',
    NoData: 'No Data',
    NoInfo: 'No Info',
    NotInvited: 'Not Invited',
    Submitted: 'Submitted',
    PartiallyApproved: 'Partially Approved',
    PartiallyDeclined: 'Partially Declined',
    PartiallySubmitted: 'Partially Submitted',
    ResyncNeeded: 'Resync Needed',
    WrongSettings: 'Wrong Settings',
  },
  provision: {
    Adminsuccessfullyinvited: 'Admin successfully invited!',
    CompanyID: 'Company ID',
    Confirm: 'Confirm',
    Continue: 'Continue',
    DeferEntitySelection: 'Defer Entity selection',
    Email: 'Email',
    EmailinIntacct: 'Email in Intacct',
    Entertheprotectionpasswordtocontinue: 'Enter the protection password to continue',
    EnterWSUCredentials: 'Enter Web Services User Credentials',
    GotoLogin: 'Go to Login',
    IntacctLogin: 'Intacct Login',
    IntacctPassword: 'Intacct Password',
    IntacctUserId: 'Intacct User ID',
    InviteAdmin: 'Invite Admin',
    InviteandProvision: 'Invite and Provision',
    Name: 'Name',
    Pleaseselecttenanttype: 'Tenant Type',
    ProvisionerEmail: 'Provisioner Email',
    ProtectionPassword: 'Protection Password',
    ProvisionerPassword: 'Provisioner Password',
    SelectEntity: 'Select Entity',
    SelectanEntityNow: 'Select an Entity now',
    SelectIntacctUser: 'Select Intacct User',
    SelectTopLevel: 'Select "Top Level"',
    StepCount: 'Step %{current} of %{total}',
    steps: {
      Step1: 'Enter Credentials',
      Step2: 'Select Entity',
      Step3: 'Connect with Intacct',
      Step4: 'Invite Admin',
    },
    TopLevelWarning: 'Warning: Data from other entities will not be included',
    UserID: 'User ID',
    Username: 'Username',
    VerifyProvisioning: 'Verify Provisioning',
    Verify: 'Verify',
    WSUID: 'Web Services User ID',
    WSUPassword: 'Web Services User Password',
  },
  reset: {
    ConfirmNewPassword: 'Confirm New Password',
    HIDE: 'HIDE',
    Login: 'Login',
    NewPassword: 'New Password',
    NoMatch: "Passwords don't match",
    ResetPassword: 'Reset Your Password',
    Save: 'Save',
    SHOW: 'SHOW',
    SuccessMessage: 'Password reset successfully, please click the button below to login.',
    ResetSuccess: 'Your password was reset successfully.',
  },
  settings: {
    demoSettings: {
      Activitiesgeneratedsuccessfully: 'Activities generated successfully',
      Customer: '**Customer**',
      GenerateActivityCards: 'Generate Activity Cards',
      GenerateActivityCardsForThisUser: 'Generate activity cards for this user',
      helmet: 'Demo Settings',
      Includeoverlappingactivity: 'Include overlapping activity',
      Pleaseselectthedate1:
        'Please select the date, customer, project, and task that you’d like activity cards to demo. Four cards with varying predictions will be generated for the selected date and available on all timesheets that include that date. If you’re having issues, please ensure this user is assigned to projects and tasks with valid dates and active customers in Intacct and then [Sync Manually](/settings/advanced) and try again. Please see ',
      Pleaseselectthedate2: ' for details.',
      Project: '**Project**',
      Select: 'Select',
      SpreadDates: 'Spread activities ±1 day from the selected date',
      subtitle: 'This page is intended for internal/demo use only!',
      Task: '**Task**',
      title: 'Demo Settings',
    },
    advanced: {
      AllowNegativeHours: 'Allow Negative Hours',
      Areyousureyouwouldliketodeactivate: "Are you sure you would like to deactivate %{name}'s SIT account?",
      Continuetoaccountdeactivation: 'Continue to account deactivation',
      DataRetentionforAllEmployees: 'Data Retention for All Employees',
      DataRetentionWarning:
        "Sage Intelligent Time retains data from the [Data Sources](/data-sources) you connect to help improve its capabilities to predict how activities are assigned. Reducing the retention period of data for your company's users may impact the quality of these predictions and consequently the accuracy and the time it takes for your employees to complete their timesheets. Employees may choose a period less than this default setting if they choose.",
      days: 'days',
      UpdateIntacctCredentials: 'Update Intacct credentials',
      Deactivate: 'Deactivate',
      DeactivateSIT: 'Deactivate SIT',
      IntacctCredentialsUpdated: 'Intacct credentials were updated successfully',
      IntacctSync: 'Intacct Sync',
      IntacctSyncManual: 'Sync manually',
      IntacctSyncFailed: 'Sync failed with error:',
      IntacctSyncRunning: 'Sync started %{syncStart}',
      IntacctSyncSuccess: 'Synced successfully %{syncEnd}',
      DeleteWarning:
        'Continuing here will deactivate Sage Intelligent Time for your entire company. It is advised to consult with our support team or professional services before proceeding.',
      Dontdeactivate: "Don't deactivate",
      EntityWarning:
        'Continuing here will set the Intacct entity in which Sage Intelligent Time uses to track time. It is strongly advised to consult with our support team or professional services before proceeding.',
      helmet: 'Settings | Advanced',
      OK: 'OK',
      PleaseselectanEntity: 'Please select an Entity',
      RequireMFA: 'Require Two-Step Verification For All Employees',
      RetainEmployeeActivitiesDataFor: 'Retain Employee Time Assistant Data For',
      RetainEmployeeCalendarDataFor: 'Retain Employee Calendar Data For',
      RetainEmployeeEmailDataFor: 'Retain Employee Email Data For',
      SelectCompanyEntity: 'Select Company Entity',
      EntitySetSuccess: 'The entity was set successfully',
      SelectEntity: 'Select Entity',
      subtitle:
        '**IMPORTANT:** These advanced settings require assistance from professional services or support. If you hired a service provider to assist with implementing Sage Intelligent Time, they will contact you directly regarding next steps. We strongly recommend that you wait to complete these settings until your service provider engages with you to help. This will ensure a smooth implementation or deactivation of SIT. If you have questions or need further assistance, please contact your Sage Intacct Account Manager directly.',
      SuccessMessageInModal: "You've successfully deactivated %{name}'s Sage Intelligent Time account.",
      Thiscannotbeundone: 'This cannot be undone.',
      title: 'Advanced Settings',
      TypeDEACTIVATESITtocontinue: 'Type "DEACTIVATE SIT" to continue.',
    },
    billing: {
      button: 'Upgrade Plan',
      helmet: 'Settings | Billing',
      subtitle: 'Manage your subscription.',
      title: 'Billing',
      YouHaveXDaysRemaining: 'You have **{{days}}** days remaining.',
    },
    downloadApp: {
      bullet1: 'Create manual entries',
      bullet2: 'Use your calendar email and computer activity to easily create accurate timesheet entries',
      bullet3: 'Manage timesheet notifications',
      bullet4: 'Bill more time and spend less time on time entry',
      bullet5: 'Maintain full control over your connected data sources - see our [Privacy Policy](/privacy) to learn more',
      helmet: 'Download App | Billing',
      subtitle: 'Sage Intelligent Time is available anytime and anywhere with our mobile app.',
      title: 'Download App',
      Withourmobileappyoucando: 'With our mobile app, you can do the following:',
    },
    general: {
      button: 'Update Company',
      CompanyAvatar: 'Company Avatar',
      CompanyName: 'Company Name',
      Currency: 'Currency',
      helmet: 'Settings | General',
      subtitle: 'Update your company name.',
      title: 'General Settings',
      UploadImage: 'Upload Image',
    },
    notifications: {
      Approvals: 'Approvals',
      DayOfWeekToReceiveNotificationEmail: 'Day Of Week To Receive Notification Email',
      Daily: 'Daily',
      days: {
        Sunday: 'Sunday',
        Monday: 'Monday',
        Tuesday: 'Tuesday',
        Wednesday: 'Wednesday',
        Thursday: 'Thursday',
        Friday: 'Friday',
        Saturday: 'Saturday',
      },
      DataSources: 'Data Sources',
      days_: 'days',
      daysaftertheendofthetimesheetperiod: 'days after the end of the timesheet period',
      daysafterthestartofthetimesheetperiod: 'days after the start of the timesheet period',
      DesktopPush: 'Desktop Push',
      Email: 'Email',
      for: 'for',
      helmet: 'Settings | Notifications',
      Notifymevia: 'Notify me via:',
      ontheselecteddays: 'on the selected days',
      RealTime: 'Real-Time',
      Receivenotifications: 'Receive notifications',
      RemindmeifIhavententeredanytimeby: 'Remind me if I haven’t entered any time by',
      SendNotificationsForTrackerApp: 'Send Notifications For Tracker App',
      SendNotificationsForCalendar: 'Send Notifications For Calendar',
      SendNotificationsForEmail: 'Send Notifications For Email',
      subtitle: 'Manage how you receive notifications.',
      Timesheet: 'Timesheet',
      Timesheethasbeeninmyqueuefor: 'Timesheet has been in my queue for',
      title: 'Notifications',
      TurnOnNotifications: 'Turn On Notifications',
      WebNotification: 'Web Notification',
      Weekly: 'Weekly',
      Whenacalendaraccountisntconnectedproperly: 'When a calendar account isn’t connected properly',
      Whenallorpartofmytimesheethasbeendeclined: 'When all or part of my timesheet has been declined',
      Whenanemailaccountisntconnectedproperly: 'When an email account isn’t connected properly',
      WhenIhavenewtimesheetsinmyqueuetoapprove: 'When I have new timesheets in my queue to approve',
      WhenIhaventcreatedatimesheet: 'When I haven’t created a timesheet',
      WhenIhaventsubmittedatimesheet: 'When I haven’t submitted a timesheet',
      WhentheTimeAssistantisntconnectedproperly: 'When the Time Assistant isn’t connected properly',
      Whenmytimesheethasbeenapproved: 'When my timesheet has been approved',
      NotifyWhen: 'Notify me when:',
      SubmissionSucceeded: 'Timesheet submission succeeded',
    },
    security: {
      badPassword:
        'New password must be at least 8 characters long, contain at least one lowercase(a-z), one uppercase(A-Z), one digit(0-9) and one symbol(!,@,#, etc.)',
      Back: 'Back',
      button: 'Save Changes',
      Cancel: 'Cancel',
      ChangePassword: 'Change Password',
      Continue: 'Continue',
      Country: 'Country',
      CurrentPassword: 'Current Password',
      DisableTwoStepVerification: 'Disable Two-Step Verification',
      Done: 'Done',
      EnableTwoStepVerification: 'Enable Two-Step Verification',
      Enteryourmobilephonenumber: 'Enter your mobile phone number. Data charges may apply – check with your mobile carrier.',
      Forsecuritypleaseenter: 'For security, please re-enter your password.',
      Fromnowon:
        "From now on, when you sign into Sage Intelligent Time on the web, mobile, or Time Assistant, you'll need to enter the security code sent to your phone. Data charges may apply – check with your mobile carrier.",
      GetStarted: 'Get Started',
      helmet: 'Settings | Security',
      Ifyoudisabletwostep:
        'If you disable two-step verification, then you will only need your email and password to log into Sage Intelligent Time or link a new device.',
      Invalidphonenumber: 'Invalid phone number',
      EnforcedAcrossOrg: 'Enforced across your organization',
      NewPassword: 'New Password',
      Password: 'Password',
      Phonenumber: 'Phone number',
      Requireasecuritycode: 'Require a security code in addition to your password',
      Securitycode: 'Security code',
      Setauniquepassword: 'Set a unique password for your Sage Intelligent Time account.',
      stepOneDescription:
        "Two-step verification adds an extra layer of protection to your account. Whenever you sign in to any Sage Intelligent Time application, you'll need to enter both your password and also a verification code sent to your mobile device via text message.",
      stepOneMfaRequired: '**Two-step verification is required by your company.**',
      subtitle: 'Manage your security settings.',
      title: 'Security',
      TwoStepVerification: 'Two-Step Verification',
      Wellsendasecuritycode:
        "We'll send a security code to this phone number when you sign into Sage Intelligent Time on the web, mobile, or Time Assistant.",
      Wevesentasecuritycodeto: "We've sent a security code to %{phoneNumber}. Enter it below to verify your phone number.",
    },
    Settings: 'Settings',
    timeGathering: {
      Anewrow: 'A new row',
      AssignActivityCardAs: 'Assign Activity Card As',
      CustomTimezone: 'Custom Timezone',
      DefaultShowWeekend: 'Default Show Weekend',
      DefaultTimesheetView: 'Default Timesheet View',
      DisplayIntacctID: 'Display Intacct ID',
      helmet: 'Settings | Time Gathering',
      IntacctIdHelpTooltip: 'Enable this to include the Intacct ID in Customer, Project, Task and Item names.',
      Mergedwithexistingrow: 'Merged with existing row',
      MergeTooltip:
        'When assigning an activity card, by default decide if you want to have it be merged with an existing timesheet row, or added to a new timesheet row.',
      minutes: 'minutes',
      subtitle: 'Manage the hours when activities are gathered, hour rounding and more.',
      TimeIncrementStep: 'Time Increment Step',
      Timezone: 'Timezone',
      title: 'Time Gathering',
      GatherActivitiesFrom: 'Gather Activities From',
    },
    userManagement: {
      ActiveUsers: 'Active Users',
      Activate: 'Activate',
      Add: 'Add',
      AllUsers: 'All Users',
      Cancel: 'Cancel',
      CancelInvitation: 'Cancel Invitation',
      Deactivate: 'Deactivate',
      Department: 'Department',
      EditUser: 'Edit User',
      Email: 'Email',
      Employee: 'Employee',
      EmployeeId: 'Employee ID',
      helmet: 'Settings | User Management',
      InactiveUsers: 'Inactive Users',
      Invitations: 'Invitations',
      Invite: 'Invite',
      InviteUsers: 'Invite Users',
      Location: 'Location',
      Manager: 'Manager',
      Name: 'Name',
      NotInvited: 'Not Invited',
      Remove: 'Remove',
      ResendInvitation: 'Resend Invitation',
      Role: 'Role',
      SendInvite: 'Send Invite',
      Status: 'Status',
      subtitle: 'Manage your team.',
      title: 'Manage Users',
      UserId: 'User ID',
    },
  },
  timesheet: {
    AddNegativeHours: 'Add Negative Hours',
    AddRow: 'Add Row',
    AttachFile: 'Attach File',
    Back: 'Back',
    Attachments: 'Attachments',
    BeginDate: 'Begin Date',
    Client: 'Client',
    Description: 'Description',
    Dropactivitycardhere: 'Drop activity card here or to an existing timesheet row',
    Droppingtheactivitycardhere: 'Dropping the activity card here will create a new timesheet row',
    EndDate: 'End Date',
    LastSynced: 'Last synced %{date}',
    NoSynced: 'Not synced yet',
    Pleaseaddressall: 'Please address all timesheet header and entry errors below and re-submit the timesheet.',
    Project: 'Project',
    RecallTimesheet: 'Recall Timesheet',
    Save: 'Save',
    SearchPromptText: 'Type to search',
    Status: 'Status',
    Submit: 'Submit',
    SubmitTimesheet: 'Submit Timesheet',
    Sync: 'Sync to Intacct',
    Syncing: 'Syncing...',
    Task: 'Task',
    Thistimesheethaserrorsthatmustbefixed: 'This timesheet has errors that must be fixed.',
    TimeEntries: 'Time Entries',
    Timesheet: 'Timesheet',
    Timesheetheadererrors: 'Timesheet header errors',
    TotalBillable: 'Total Billable',
    TotalHours: 'Total Hours',
    TotalNonbillable: 'Total Nonbillable',
  },
  timesheetRows: {
    Companysettingsdontallowduplicaterows: "Company settings don't allow duplicate rows",
    Youcannotassignanactivitytoanentrywithstatus: 'You cannot assign an activity to an entry with status "%{status}"',
  },
  timesheets: {
    ActiveTimesheets: 'Active Timesheets',
    Addatimesheetanditwillshowuphere: 'Add a timesheet and it will show up here.',
    AddFilter: 'Add Filter',
    After: 'After',
    AllTimesheets: 'All Timesheets',
    Apply: 'Apply',
    AreYouSure: {
      one: 'Are you sure you would like to delete the selected timesheet?',
      other: 'Are you sure you would like to delete the selected timesheets?',
      zero: 'You selected zero timesheets.',
    },
    AreYouSureSubmit: {
      one: 'Are you sure you would like to submit the selected timesheet?',
      other: 'Are you sure you would like to submit the selected timesheets?',
      zero: 'You selected zero timesheets.',
    },
    Before: 'Before',
    BeginDate: 'Begin Date',
    Cancel: 'Cancel',
    Clear: 'Clear',
    Client: 'Client',
    ColumnName: 'Column Name',
    ConfigureColumns: 'Configure Columns',
    CreateaNewTimesheet: 'Create a New Timesheet',
    CreateTimesheet: 'Create Timesheet',
    Dates: 'Dates',
    Delete: 'Delete',
    DeleteTimesheets: {
      one: 'Delete Timesheet',
      other: 'Delete %{count} Timesheets',
      zero: 'Delete 0 timesheets',
    },
    Description: 'Description',
    Duplicate: 'Duplicate',
    DuplicateTimesheet: 'Duplicate Timesheet',
    EndDate: 'End Date',
    Equalto: 'Equal to',
    Filter: 'Filter',
    Greaterthan: 'Greater than',
    InvalidTimesheetStartDate: 'Invalid start date. Select a date that is %{day}',
    InvalidTimesheetStartDateStartOrMidOfMonth: 'Invalid start date. Select the 1st or the 16th of the month',
    Lessthan: 'Less than',
    Notequalto: 'Not equal to',
    Project: 'Project',
    SelectedTimesheets: 'Selected Timesheets',
    Startbuildingyourtimesheet: 'Start building your timesheet!',
    State: 'State',
    Status: 'Status',
    Submit: 'Submit',
    SubmitTimesheet: 'Submit Timesheet',
    SubmitTimesheets: {
      one: 'Submit Timesheet',
      other: 'Submit %{count} Timesheets',
      zero: 'Submit 0 timesheets',
    },
    Task: 'Task',
    Thiscannotbeundone: 'This cannot be undone.',
    Timesheet: 'Timesheet',
    Timesheets: 'Timesheets',
    TotalAllocated: 'Total Allocated',
    TotalBillableHours: 'Total Billable Hours',
    TotalHours: 'Total Hours',
    TotalNonBillableHours: 'Total Non-Billable Hours',
    Value: 'Value',
    MustHaveEmployee: 'You must have an employee record in Intacct to create a timesheet',
  },
  verify: {
    Login: 'Login',
    SuccessMessage: 'Your email is verified, you can now click the button below to login.',
  },
};

export default en;
